import React from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { OwnerAssignmentButton as ReusableOwnerAssignmentButton } from '../../../components/Reusable/Buttons'
import { ControlMutator } from './ControlListItem.constants'

export const OwnerAssignmentButton = ({
  control,
  mutate,
  id, // Used for Risks and future models
}: {
  control: Control.AsObject
  mutate: ControlMutator
  id?: string
}): JSX.Element => (
  // The owner saves through UpdateControlFields, so the capability comes from the
  // model type; passing the control scopes the label and ownership rules to it.
  <ReusableOwnerAssignmentButton
    modelId={id || control.id}
    email={control.ownerEmail}
    isDisabled={control.isDismissed}
    onUpdate={mutate}
    modelType={MODEL_TYPE.CONTROL}
    resource={control}
  />
)
